export let CreateDeliveryInvalidTimeInstructionsType = /*#__PURE__*/function (CreateDeliveryInvalidTimeInstructionsType) {
  CreateDeliveryInvalidTimeInstructionsType[CreateDeliveryInvalidTimeInstructionsType["BOTH_PROVIDED"] = 0] = "BOTH_PROVIDED";
  CreateDeliveryInvalidTimeInstructionsType[CreateDeliveryInvalidTimeInstructionsType["NONE_PROVIDED"] = 1] = "NONE_PROVIDED";
  return CreateDeliveryInvalidTimeInstructionsType;
}({});
export class CreateDeliveryInvalidTimeInstructionsError extends Error {
  constructor(type) {
    let message = 'One of drop off time or pickup time is mandatory';
    switch (type) {
      case CreateDeliveryInvalidTimeInstructionsType.BOTH_PROVIDED:
        message = `${message}, both provided`;
        break;
      case CreateDeliveryInvalidTimeInstructionsType.NONE_PROVIDED:
        message = `${message}, none provided`;
        break;
    }
    super(message);
  }
}
//# sourceMappingURL=request-options.js.map